import { Box, SimpleGrid, Text } from '@mantine/core';
import type { IModem } from '../../../../../../shared/types/modem';
import { InfoField } from '../../../../../ui/infoField/InfoField';

export default function TelecomInfo(props: { data: IModem }) {
  const { data } = props;
  return (
    <div>
      <Text fw={600} mb="xs">
        통신 서비스 및 가입 정보
      </Text>
      <Box
        style={{
          borderTop: '1px solid var(--mantine-color-gray-3)',
          borderLeft: '1px solid var(--mantine-color-gray-3)',
        }}
      >
        <SimpleGrid cols={4} spacing={0} verticalSpacing={0}>
          <InfoField label="통신사">{data.telecom}</InfoField>
          <InfoField label="통신 요금제">{data.plan}</InfoField>
          <InfoField label="USIM 일련번호">{data.usimNo}</InfoField>
          <InfoField label="서비스 번호">{data.serviceNo}</InfoField>
        </SimpleGrid>
      </Box>
    </div>
  );
}
